/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React, { memo } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
import { css, jsx } from '@emotion/react';
var iconWrapperStyles = css({
  maxWidth: "var(--ds-space-500, 40px)",
  maxHeight: "var(--ds-space-500, 40px)",
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/design-system/no-nested-styles
  div: {
    maxWidth: "var(--ds-space-500, 40px)",
    maxHeight: "var(--ds-space-500, 40px)"
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/design-system/no-nested-styles
  span: {
    maxWidth: "var(--ds-space-500, 40px)",
    maxHeight: "var(--ds-space-500, 40px)"
  }
});
export var IconRenderer = /*#__PURE__*/memo(function (_ref) {
  var children = _ref.children;
  return jsx("div", {
    css: [iconWrapperStyles]
  }, children);
});